import React, { useEffect, useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
  fetchButtonVariables,
  updateButtonVariables,
} from "@hypexone/uicore";
import UserMenuPageTitle from "../shared/user-menu/UserMenuPageTitle";
import UserMenuInputComponent from "../shared/user-menu/UserMenuInputComponent";
import UserMenuButtonComponent from "../shared/user-menu/UserMenuButtonComponent";

interface ButtonVariable {
  label: string;
  stake: number;
}

const StakeSettings = () => {
  const dispatch = useAppDispatch();
  const { langData } = useAppSelector((state) => state.cms);
  const buttonVariables = useAppSelector(
    (state) => state.betSlip.buttonVariables
  );

  const [fieldValues, setFieldValues] = useState<ButtonVariable[]>([]);

  useEffect(() => {
    dispatch(fetchButtonVariables());
  }, [dispatch]);

  useEffect(() => {
    if (buttonVariables.length) {
      setFieldValues(buttonVariables);
    }
  }, [buttonVariables]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    key: keyof ButtonVariable
  ) => {
    const updatedFields = [...fieldValues];
    updatedFields[index] = {
      ...updatedFields[index],
      [key]: key === "stake" ? parseFloat(e.target.value) : e.target.value,
    } as ButtonVariable;
    setFieldValues(updatedFields);
  };

  const [saving, setSaving] = useState(false);
  const handleUpdate = async () => {
    setSaving(true);
    try {
      await dispatch(updateButtonVariables(fieldValues));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex flex-col sm:border sm:rounded-[4px] h-full">
      <UserMenuPageTitle title={langData?.["change_button_values"]} />

      <div className="flex flex-col gap-2 px-2 overflow-auto py-5">
        <div className="flex justify-between max-w-[700px]">
          <div className="flex flex-col w-1/2 pr-2">
            <span className="mb-2 font-semibold">
              {langData?.["price_label"]}
            </span>
            {fieldValues.map((field, index) => (
              <UserMenuInputComponent
                key={`label${index}`}
                type="text"
                placeholder={langData?.["enter_label"]}
                value={field.label}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(e, index, "label")
                }
              />
            ))}
          </div>
          <div className="flex flex-col w-1/2 pl-2">
            <span className="mb-2 font-semibold">
              {langData?.["price_value"]}
            </span>
            {fieldValues.map((field, index) => (
              <UserMenuInputComponent
                key={`value${index}`}
                type="number"
                value={field.stake}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(e, index, "stake")
                }
              />
            ))}
          </div>
        </div>
        <UserMenuButtonComponent
          buttonText={langData?.["update"]}
          customWidth
          customCSS="w-full sm:w-fit"
          onClick={handleUpdate}
          loading={saving}
        />
      </div>
    </div>
  );
};

export default StakeSettings;
